/**
 * @file The whole seconds left on one kind of the caller's report run
 * cooldown, 0 when none runs. Consumer: `AnalyticsReportRunActions`, which
 * recomputes it on every clock tick. The window starts at the instant the
 * callable last claimed it, and the two kinds never share a window.
 */
import { ANALYTICS_REPORT_RUN_COOLDOWN_SECONDS } from '#types';
import type {
  AnalyticsReportRunCooldown,
  AnalyticsReportRunCooldownKind,
} from '#types';

export const analyticsReportRunCooldownLeft = (
  cooldown: Readonly<AnalyticsReportRunCooldown> | undefined,
  kind: AnalyticsReportRunCooldownKind,
  now: number,
): number => {
  const claimedAt =
    kind === 'download'
      ? cooldown?.downloadClaimedAt
      : cooldown?.emailClaimedAt;
  if (claimedAt === undefined) return 0;
  const left =
    Date.parse(claimedAt) +
    ANALYTICS_REPORT_RUN_COOLDOWN_SECONDS[kind] * 1000 -
    now;
  return left > 0 ? Math.ceil(left / 1000) : 0;
};
